import React from 'react';

import dummy from '../images/dummy-avatar.png';
import css from './Avatar.module.css';

export const Avatar = ({ src }) => <img src={src || dummy} alt="" className={css.avatar} />;
